import { useEffect, useState } from "react";

export function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(
    () => "ontouchstart" in window || navigator.maxTouchPoints > 0
  );

  useEffect(() => {
    const updateIsTouch = () => {
      setIsTouch("ontouchstart" in window || navigator.maxTouchPoints > 0);
    };

    window.addEventListener("resize", updateIsTouch);
    return () => {
      window.removeEventListener("resize", updateIsTouch);
    };
  }, []);

  return isTouch;
}
